import React, { InputHTMLAttributes, useEffect, useRef } from "react";
import PersonalizedIcon from "../../../../../../shared/assets/customIcons/PersonalizedIcon";
import LoadingEditor from "../../../LoadingEditor";
import { ButtonIcon, Container, ContainerIcons, Label } from "./styles";

interface AutomatizeItemProps extends InputHTMLAttributes<HTMLDivElement> {
  downloading: boolean;
  document_name: string;
  document_id: string;
  currentSelectedDocument: string;
  handlePreviewDocument: (document_id: string) => void;
  handleEditDocument: (document_id: string) => void;
  handleDownloadAutomatizedDocument: (
    document_id: string,
    document_name: string
  ) => void;
  handleDeleteAutomatizedDocument: (document_id: string) => void;
  loading:
    | false
    | "download"
    | "variables"
    | "automatize"
    | "automatizing"
    | "saving"
    | "deleting"
    | "preview"
    | "pages";
  setLoading: React.Dispatch<
    React.SetStateAction<
      | false
      | "download"
      | "variables"
      | "automatize"
      | "automatizing"
      | "saving"
      | "deleting"
      | "preview"
      | "pages"
    >
  >;
}

const AutomatizedItem: React.FC<AutomatizeItemProps> = ({
  document_name,
  document_id,
  handleDeleteAutomatizedDocument,
  handleEditDocument,
  handleDownloadAutomatizedDocument,
  handlePreviewDocument,
  loading,
  setLoading,
  currentSelectedDocument,
  downloading
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <Container>
      {/*PREVIEW PROJECT BUTTON */}
      <ButtonIcon
        onClick={() => {
          setLoading("preview");
          handlePreviewDocument(document_id);
        }}
        style={{
          display: "flex",
          width: "auto",
          justifyContent: "left",
          height: "80%"
        }}
      >
        <Label style={{ cursor: "pointer" }}>
          {loading === "preview" && currentSelectedDocument === document_id ? (
            <LoadingEditor color="#000" width={30} height={30} />
          ) : (
            document_name
          )}
        </Label>
      </ButtonIcon>
      <ContainerIcons>
        {/*DOWNLOAD BUTTON */}
        <ButtonIcon
          onClick={() => {
            handleDownloadAutomatizedDocument(document_id, document_name);
          }}
        >
          {downloading && currentSelectedDocument === document_id ? (
            <LoadingEditor color="#000" width={30} height={30} />
          ) : (
            <PersonalizedIcon
              viewBox="0 0 25 25"
              height={30}
              width={30}
              className="icon"
              dPath="M0.25 21.998H17.75V19.498H0.25V21.998ZM17.75 8.24805H12.75V0.748047H5.25V8.24805H0.25L9 16.998L17.75 8.24805Z"
            />
          )}
        </ButtonIcon>

        {/*EDIT BUTTON */}
        <ButtonIcon
          onClick={() => {
            handleEditDocument(document_id);
          }}
        >
          <PersonalizedIcon
            viewBox="0 0 25 25"
            height={30}
            width={30}
            className="icon"
            dPath="M14.575 7.5L15.75 8.675L4.4 20H3.25V18.85L14.575 7.5ZM19.075 0C18.7625 0 18.4375 0.125 18.2 0.3625L15.9125 2.65L20.6 7.3375L22.8875 5.05C23.375 4.5625 23.375 3.75 22.8875 3.2875L19.9625 0.3625C19.7125 0.1125 19.4 0 19.075 0ZM14.575 3.9875L0.75 17.8125V22.5H5.4375L19.2625 8.675L14.575 3.9875Z"
          />
        </ButtonIcon>

        {/*DELETE BUTTON */}
        <ButtonIcon
          onClick={() => {
            handleDeleteAutomatizedDocument(document_id);
          }}
        >
          <PersonalizedIcon
            viewBox="0 0 25 25"
            height={30}
            width={30}
            className="icon"
            dPath="M5.55555 0.998047V2.10916H0V4.33138H1.11111V18.7758C1.11111 19.3652 1.34524 19.9304 1.76198 20.3472C2.17873 20.7639 2.74396 20.998 3.33333 20.998H14.4444C15.0338 20.998 15.599 20.7639 16.0158 20.3472C16.4325 19.9304 16.6667 19.3652 16.6667 18.7758V4.33138H17.7778V2.10916H12.2222V0.998047H5.55555ZM3.33333 4.33138H14.4444V18.7758H3.33333V4.33138ZM5.55555 6.5536V16.5536H7.77778V6.5536H5.55555ZM10 6.5536V16.5536H12.2222V6.5536H10Z"
          />
        </ButtonIcon>
      </ContainerIcons>
    </Container>
  );
};

export default AutomatizedItem;

